/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Article_Proxy_Printing_TitleInputs */



/**
* | output |
* | --- |
* | "Printing Proxies" |
*
* @param {Help_Article_Proxy_Printing_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const help_article_proxy_printing_title = /** @type {((inputs?: Help_Article_Proxy_Printing_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Article_Proxy_Printing_TitleInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Proxys drucken")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Imprimer des proxys")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("打印替代卡")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("列印替代牌")
	if (locale === "ko") return /** @type {LocalizedString} */ ("대용 카드 인쇄")
	return /** @type {LocalizedString} */ ("Printing Proxies")
});